<div class="sidebar-container">
  <div>
    <!-- Main Menu starts Here -->
    <div *ngIf="sideMenu == 'main_menu'" class="secondary_menu">
      <mat-selection-list [multiple]="false">
        <ng-container *ngFor="let menu of platFormLevelMenu">
          <!-- Menu 1st hierarchy starts here-->

          <mat-list-option
            *ngIf="
              menu.name == 'CDP'
                ? user_cdp_enabled && cdpAllowed
                : menu.entityGroup == 'pl'
                ? checkPLReportPms()
                : menu.group == 'notification' && this.role == 'agency_account_manager'
                ? false
                : menu.listPer
                ? getListPermission(menu.listPer)
                : getViewPermission(menu.viewPer)
            "
            [ngClass]="{
              selected_submenu_item: menu.entityGroup
                ? selectedEntityGroup == menu.entityGroup
                : selectedOptionsGroup == menu.group,
              expandable_options: true
            }"
            (click)="
              selectCategoryOptions(
                null,
                menu.navLink,
                menu.entityGroup ? getPlatFormType() : menu.dspType,
                menu.entityGroup
                  ? this.selectedEntityGroup != menu.entityGroup
                  : selectedOptionsGroup != menu.group,
                menu.adspRegion,
                menu.entityGroup,
                false,
                menu.name == 'CDP'
              )
            "
            [selected]="
              menu.entityGroup
                ? selectedEntityGroup == menu.entityGroup
                : selectedOptionsGroup == menu.group
            "
          >
            <div class="expand_options">
              <span
                [matTooltip]="menu.toolTip ? menu.toolTip : ''"
                [ngClass]="{
                  expand_options_title: true,
                  selected_submenu_title: menu.entityGroup
                    ? selectedEntityGroup == menu.entityGroup
                    : selectedOptionsGroup == menu.group,
                  'active-sub-option': menu.entityGroup
                    ? selectedEntityGroup == menu.entityGroup
                    : selectedOptionsGroup == menu.group
                }"
              >
                <ng-container *ngIf="menu.faIconClass; else matIcon">
                  <i [className]="menu.faIconClass"></i>
                </ng-container>

                <ng-template #matIcon>
                  <ng-container *ngIf="menu.matIconClass; else textIcon">
                    <mat-icon class="me-3">{{ menu.matIconClass }}</mat-icon>
                  </ng-container>
                </ng-template>

                <ng-template #textIcon>
                  <span class="me-3 text-icon">{{ menu.textIcon }}</span>
                </ng-template>

                {{ menu.name }}
              </span>

              <ng-container *ngIf="menu.children && menu.children.length > 0">
                <mat-icon
                  *ngIf="selectedEntityGroup == menu.entityGroup"
                  class="expand_options_icon material-icons-outlined"
                >
                  expand_less
                </mat-icon>
                <mat-icon
                  class="expand_options_icon material-icons-outlined"
                  *ngIf="selectedEntityGroup != menu.entityGroup"
                >
                  expand_more
                </mat-icon>
              </ng-container>
            </div>
          </mat-list-option>

          <!-- Menu 1st hierarchy ends here -->

          <div *ngIf="selectedEntityGroup == menu.entityGroup" class="ms-3">
            <ng-container *ngFor="let subMenu of menu.children">
              <!-- Menu 2nd hierarchy starts here -->

              <mat-list-option
                [matTooltip]="subMenu.toolTip ? subMenu.toolTip : ''"
                *ngIf="
                  plfLibrariesGrp.has(subMenu.group)
                    ? checkPlfLibPms()
                    : pLReportGrp.has(subMenu.group)
                    ? checkPLReportPms()
                    : menu.listPer
                    ? getListPermission(subMenu.listPer)
                    : getViewPermission(subMenu.viewPer)
                "
                [ngClass]="{
                  expandable_options: true,
                  selected_submenu_item: selectedOptionsGroup == subMenu.group
                }"
                (click)="
                  selectCategoryOptions(
                    subMenu.group,
                    subMenu.navLink,
                    subMenu.adspSeat,
                    subMenu.navigation,
                    subMenu.adspRegion,
                    menu.entityGroup
                  )
                "
                [selected]="selectedOptionsGroup == subMenu.group"
              >
                <div class="expand_options">
                  <span
                    class="nav-link expand_options_title"
                    [ngClass]="{
                      selected_submenu_title:
                        selectedOptionsGroup == subMenu.group,
                      'active-sub-option': selectedOptionsGroup == subMenu.group
                    }"
                  >
                    <ng-container *ngIf="subMenu.faIconClass; else matIcon">
                      <i [className]="subMenu.faIconClass"></i>
                    </ng-container>

                    <ng-template #matIcon>
                      <ng-container *ngIf="subMenu.matIconClass; else textIcon">
                        <mat-icon class="me-3">{{
                          subMenu.matIconClass
                        }}</mat-icon>
                      </ng-container>
                    </ng-template>

                    <ng-template #textIcon>
                      <span class="me-3 text-icon">{{ subMenu.textIcon }}</span>
                    </ng-template>

                    {{ subMenu.name }}
                  </span>

                  <ng-container
                    *ngIf="subMenu.children && subMenu.children.length > 0"
                  >
                    <mat-icon
                      *ngIf="selectedOptionsGroup == subMenu.group"
                      class="expand_options_icon material-icons-outlined"
                    >
                      expand_less
                    </mat-icon>
                    <mat-icon
                      class="expand_options_icon material-icons-outlined"
                      *ngIf="selectedOptionsGroup !== subMenu.group"
                    >
                      expand_more
                    </mat-icon>
                  </ng-container>
                </div>
              </mat-list-option>

              <!-- Menu 2nd hierarchy ends here -->

              <ng-container
                *ngIf="subMenu.children && subMenu.children.length > 0"
              >
                <div *ngIf="selectedOptionsGroup == subMenu.group" class="ms-3">
                  <mat-nav-list role="list">
                    <!-- Menu 3rd hierarchy starts here -->

                    <ng-container
                      *ngFor="
                        let subMenuChild of subMenu.children;
                        let lastMenu = last
                      "
                    >
                      <mat-list-item
                        *ngIf="
                          subMenuChild.group == 'deals'
                            ? role == 'platform_superadmin'
                              ? getListPermission(subMenuChild.listPer)
                              : getListPermission(subMenuChild.listPer) &&
                                !whiteLabelMode &&
                                !isTdspFixedPricing()
                            : subMenuChild.listPer
                            ? getListPermission(subMenuChild.listPer)
                            : getViewPermission(subMenuChild.viewPer)
                        "
                        (click)="
                          subMenuChild.navLink
                            ? routeURL({ routes: subMenuChild.navLink })
                            : routeToViewReport(subMenu.dspType, true)
                        "
                        suboptionSelected="option.group"
                        [ngClass]="{
                          'border-bottom': lastMenu,
                          'nav-menu-list-item': true
                        }"
                      >
                        <mat-icon
                          [ngClass]="{
                            'active-sub-option':
                              suboptionSelected == subMenuChild.group
                          }"
                        >
                          {{ subMenuChild.matIconClass }}
                        </mat-icon>

                        <ng-container
                          *ngIf="!subMenuChild.navLink; else displayName"
                        >
                          <span
                            [ngClass]="{
                              'active-sub-option bold':
                                suboptionSelected == subMenuChild.group,
                              disable: accessViewReport(subMenu.dspType, true)
                                ? true
                                : false
                            }"
                          >
                            {{ subMenuChild.name }}
                          </span>
                        </ng-container>

                        <ng-template #displayName>
                          <a
                            [ngClass]="{
                              'nav-link': true,
                              'active-sub-option bold':
                                suboptionSelected == subMenuChild.group
                            }"
                            routerLinkActive="active-list-item"
                          >
                            {{ subMenuChild.name }}
                          </a>
                        </ng-template>
                      </mat-list-item>
                    </ng-container>
                    <!-- Menu 3rd hierarchy ends here -->
                  </mat-nav-list>
                </div>
              </ng-container>
            </ng-container>
          </div>
        </ng-container>
      </mat-selection-list>
    </div>
    <!-- Main Menu ends Here -->

    <!-- Platform Menu/Agency Menu starts Here -->

    <div *ngIf="sideMenu == 'platform_menu'" class="secondary_menu">
      <!-- Agency Back Menu Starts Here -->

      <div>
        <div
          *ngIf="platformMenuBackAllowed()"
          class="landing_page_link landing_page_link_padding"
        >
          <span class="landing_page_link_icon">
            <i class="fas fa-caret-left"></i>
          </span>
          <span class="landing_page_link_title cursor_pointer">
            <a
              style="color: black"
              [routerLink]="['/agency']"
              (click)="selectedOptionsGroup = 'agency'"
            >
              Back to Agencies
            </a>
          </span>
        </div>
        <!-- Agency Back Menu ends Here -->

        <mat-selection-list [multiple]="false">
          <ng-container
            *ngFor="let menu of agencyLevelMenu; let lastMenu = last"
          >
            <!-- Menu 1st hierarchy starts here-->

            <mat-list-option
              *ngIf="menu.name == 'CDP'
                  ? cdp_enabled && user_cdp_enabled && cdpAllowed
                  : isClientWithPerm(menu)
              "
              [ngClass]="{
                selected_submenu_item: menu.entityGroup
                  ? selectedEntityGroup == menu.entityGroup
                  : selectedOptionsGroup == menu.group,
                expandable_options: true
              }"
              (click)="
                selectCategoryOptions(
                  null,
                  getMenuNavLink(menu),
                  menu.entityGroup ? getPlatFormType() : menu.dspType,
                  menu.entityGroup
                    ? this.selectedEntityGroup != menu.entityGroup
                    : selectedOptionsGroup != menu.group,
                  getAdspRegion(),
                  menu.entityGroup,
                  false,
                  menu.name == 'CDP'
                )
              "
              [selected]="
                menu.entityGroup
                  ? selectedEntityGroup == menu.entityGroup
                  : selectedOptionsGroup == menu.group
              "
            >
              <div class="expand_options">
                <span
                  [matTooltip]="menu.toolTip ? menu.toolTip : ''"
                  [ngClass]="{
                    expand_options_title: true,
                    selected_submenu_title: menu.entityGroup
                      ? selectedEntityGroup == menu.entityGroup
                      : selectedOptionsGroup == menu.group,
                    'active-sub-option': menu.entityGroup
                      ? selectedEntityGroup == menu.entityGroup
                      : selectedOptionsGroup == menu.group
                  }"
                >
                  <ng-container *ngIf="menu.faIconClass; else matIcon">
                    <i [className]="menu.faIconClass"></i>
                  </ng-container>

                  <ng-template #matIcon>
                    <ng-container *ngIf="menu.matIconClass; else textIcon">
                      <mat-icon class="me-3">{{ menu.matIconClass }}</mat-icon>
                    </ng-container>
                  </ng-template>

                  <ng-template #textIcon>
                    <span class="me-3 text-icon">{{ menu.textIcon }}</span>
                  </ng-template>

                  {{ menu.name }}
                </span>

                <ng-container *ngIf="menu.children && menu.children.length > 0">
                  <mat-icon
                    *ngIf="selectedEntityGroup == menu.entityGroup"
                    class="expand_options_icon material-icons-outlined"
                  >
                    expand_less
                  </mat-icon>
                  <mat-icon
                    class="expand_options_icon material-icons-outlined"
                    *ngIf="selectedEntityGroup != menu.entityGroup"
                  >
                    expand_more
                  </mat-icon>
                </ng-container>
              </div>
            </mat-list-option>

            <!-- Menu 1st hierarchy ends here-->

            <div *ngIf="selectedEntityGroup == menu.entityGroup" class="ms-3">
              <ng-container *ngFor="let subMenu of menu.children">
                <!-- Menu 2nd hierarchy starts here-->

                <div
                  [matTooltip]="
                    role == 'managed_agency_user'
                      ? getToolTip(subMenu.dspType)
                      : ''
                  "
                >
                  <mat-list-option
                    [matTooltip]="subMenu.toolTip ? subMenu.toolTip : ''"
                    *ngIf="
                    subMenu.dspType == 'tdsp_hyperlocal' ? isHyperlocalMenuAllowed(subMenu) && dspTypes[subMenu.dspType]:
                      subMenu.dspType == 'nonDSP'
                        ? isClientWithPerm(subMenu)
                        : subMenu.dspType == 'vdsp'? dspTypes[subMenu.dspType] && platformRole : dspTypes[subMenu.dspType] 
                    "
                    [ngClass]="{
                      selected_submenu_item:
                        subMenu.dspType == 'nonDSP'
                          ? selectedOptionsGroup == subMenu.group
                          : selectedPlatformType == subMenu.dspType,
                      expandable_options: true
                    }"
                    [disabled]="
                      role == 'managed_agency_user'
                        ? isDspDisabled(subMenu.dspType)
                        : false
                    "
                    (click)="
                      selectCategoryOptions(
                        getGroup(subMenu, 'agency'),
                        getSubMenuNavLink(subMenu, 'agency'),
                        subMenu.dspType,
                        !subMenu.children
                          ? true
                          : selectedPlatformType != subMenu.dspType,
                        subMenu.adspRegion,
                        menu.entityGroup
                      )
                    "
                    [selected]="selectedPlatformType == subMenu.dspType"
                  >
                    <div class="expand_options">
                      <span
                        [ngClass]="{
                          expand_options_title: true,
                          selected_submenu_title:
                            subMenu.dspType == 'nonDSP'
                              ? selectedOptionsGroup == subMenu.group
                              : selectedPlatformType == subMenu.dspType,
                          'active-sub-option':
                            subMenu.dspType == 'nonDSP'
                              ? selectedOptionsGroup == subMenu.group
                              : selectedPlatformType == subMenu.dspType
                        }"
                      >
                        <ng-container *ngIf="subMenu.faIconClass; else matIcon">
                          <i [className]="subMenu.faIconClass"></i>
                        </ng-container>

                        <ng-template #matIcon>
                          <ng-container
                            *ngIf="subMenu.matIconClass; else textIcon"
                          >
                            <mat-icon class="me-3">{{
                              subMenu.matIconClass
                            }}</mat-icon>
                          </ng-container>
                        </ng-template>

                        <ng-template #textIcon>
                          <span class="me-3 text-icon">{{
                            subMenu.textIcon
                          }}</span>
                        </ng-template>

                        {{ subMenu.name }}
                      </span>

                      <ng-container
                        *ngIf="subMenu.children && subMenu.children.length > 0"
                      >
                        <mat-icon
                          *ngIf="selectedPlatformType == subMenu.dspType"
                          class="expand_options_icon material-icons-outlined"
                        >
                          expand_less
                        </mat-icon>

                        <mat-icon
                          class="expand_options_icon material-icons-outlined"
                          *ngIf="selectedPlatformType !== subMenu.dspType"
                        >
                          expand_more
                        </mat-icon>
                      </ng-container>
                    </div>
                  </mat-list-option>
                </div>

                <!-- Menu 2nd hierarchy ends here-->

                <div
                  *ngIf="selectedPlatformType == subMenu.dspType"
                  class="ms-3"
                >
                  <ng-container *ngFor="let subMenuChild of subMenu.children">
                    <!-- Menu 3rd hierarchy starts here-->
                    <div
                      *ngIf="
                        agencyReportAnalyticsGrp.has(subMenuChild.group)
                          ? checkAgcReportsPms(subMenuChild)
                          : subMenuChild.listPer
                          ? getListPermission(subMenuChild.listPer)
                          : getViewPermission(subMenuChild.viewPer)
                      "
                      [matTooltip]="
                        isDashboardComingSoon(subMenu, subMenuChild)
                          ? 'Coming Soon'
                          : ''
                      "
                      [style.cursor]="
                        isDashboardComingSoon(subMenu, subMenuChild)
                          ? 'not-allowed'
                          : 'pointer'
                      "
                    >
                      <mat-list-option
                      
                        [ngClass]="{
                          expandable_options: true,
                          selected_submenu_item:
                            !isDashboardComingSoon(subMenu, subMenuChild) &&
                            selectedOptionsGroup == subMenuChild.group,
                          report_background: subMenuChild.listPer == 'report',
                          coming_soon_section: isDashboardComingSoon(
                            subMenu,
                            subMenuChild
                          )
                        }"
                        (click)="
                          isDashboardComingSoon(subMenu, subMenuChild)
                            ? $event.stopPropagation()
                            : selectCategoryOptions(
                                subMenuChild.group,
                                subMenuChild.navLink,
                                subMenu.dspType,
                                !subMenuChild.subMenuOptions
                                  ? true
                                  : selectedOptionsGroup != subMenuChild.group,
                                subMenu.adspRegion,
                                menu.entityGroup,
                                true
                              )
                        "
                      >
                        <div class="expand_options">
                          <span
                            [ngClass]="{
                              'nav-link': true,
                              expand_options_title: true,
                              selected_submenu_title:
                                selectedOptionsGroup == subMenuChild.group,
                              'active-sub-option':
                                selectedOptionsGroup == subMenuChild.group
                            }"
                          >
                            <ng-container
                              *ngIf="subMenuChild.faIconClass; else matIcon"
                            >
                              <i [className]="subMenuChild.faIconClass"></i>
                            </ng-container>

                            <ng-template #matIcon>
                              <ng-container
                                *ngIf="subMenuChild.matIconClass; else textIcon"
                              >
                                <mat-icon class="me-3">{{
                                  subMenuChild.matIconClass
                                }}</mat-icon>
                              </ng-container>
                            </ng-template>

                            <ng-template #textIcon>
                              <span class="me-3 text-icon">{{
                                subMenuChild.textIcon
                              }}</span>
                            </ng-template>

                            {{ subMenuChild.name }}
                          </span>

                          <ng-container *ngIf="subMenuChild.children?.length > 0">
                            <mat-icon
                              *ngIf="selectedOptionsGroup == subMenuChild.group"
                              class="expand_options_icon material-icons-outlined"
                            >
                              expand_less
                            </mat-icon>
                            <mat-icon
                              class="expand_options_icon material-icons-outlined"
                              *ngIf="selectedOptionsGroup !== subMenuChild.group"
                            >
                              expand_more
                            </mat-icon>
                          </ng-container>
                        </div>
                      </mat-list-option>
                    </div>

                    <!-- Menu 3rd hierarchy ends here-->

                    <ng-container *ngIf="subMenuChild.children?.length > 0">
                      <div
                        *ngIf="
                          selectedOptionsGroup == subMenuChild.group &&
                          getListPermission(subMenuChild.listPer)
                        "
                        class="ms-3"
                      >
                        <mat-nav-list role="list">
                          <!-- Menu 4th hierarchy starts here-->

                          <ng-container
                            *ngFor="
                              let childOption of subMenuChild.children;
                              let lastsubMenu = last
                            "
                          >
                            <mat-list-item
                              [ngClass]="{
                                'border-bottom': lastsubMenu,
                                'nav-menu-list-item': true
                              }"
                              *ngIf="
                                childOption.listPer === 'deal_client_view'
                                  ? !isTdspFixedPricing() && getListPermission(childOption.listPer)
                                  : getListPermission(childOption.listPer)
                              "
                              (click)="
                                childOption.navLink
                                  ? routeURL(
                                      { routes: childOption.navLink },
                                      subMenu.adspRegion
                                    )
                                  : routeToViewReport(subMenu.dspType);
                                childOption.navLink
                                  ? (suboptionSelected = childOption.group)
                                  : ''
                              "
                            >
                              <mat-icon
                                [ngClass]="{
                                  'active-sub-option':
                                    suboptionSelected == childOption.group
                                }"
                              >
                                {{ childOption.matIconClass }}
                              </mat-icon>

                              <a
                                [ngClass]="{
                                  'nav-link': true,
                                  'active-sub-option bold':
                                    suboptionSelected == childOption.group
                                }"
                                routerLinkActive="active-list-item"
                              >
                                <ng-container
                                  *ngIf="!childOption.navLink; else displayName"
                                >
                                  <span
                                    [ngClass]="{
                                      disable: accessViewReport(subMenu.dspType)
                                        ? true
                                        : false
                                    }"
                                    (click)="routeToViewReport(subMenu.dspType)"
                                  >
                                    {{ childOption.name }}
                                  </span>
                                </ng-container>

                                <ng-template #displayName>
                                  {{ childOption.name }}
                                </ng-template>
                              </a>
                            </mat-list-item>
                          </ng-container>
                        </mat-nav-list>
                      </div>
                    </ng-container>
                    <!-- Menu 4th hierarchy ends here-->
                  </ng-container>
                </div>
              </ng-container>
            </div>
          </ng-container>
        </mat-selection-list>
      </div>
    </div>
    <!-- Platform Menu/Agency Menu ends Here -->

    <!-- Advertiser Menu starts Here -->

    <div *ngIf="sideMenu == 'advertiser_menu'" class="secondary_menu">
      <!-- Advertiser Go Back Menu starts here -->
      <div>
        <div
          *ngIf="advertiserMenuBackAllowed()"
          class="landing_page_link landing_page_link_padding"
        >
          <span class="landing_page_link_icon">
            <i class="fas fa-caret-left"></i>
          </span>
          <span class="landing_page_link_title cursor_pointer">
            <a style="color: black" (click)="advertiserMenuBackAction()">
              Back to
              {{ getSavedAdvertiser() ? "Advertisers" : "Agency Advertisers" }}
            </a>
          </span>
        </div>
        <!-- Advertiser Go Back Menu ends here -->

        <mat-selection-list [multiple]="false">
          <ng-container
            *ngFor="let menu of advertiserLevelMenu; let lastMenu = last"
          >
            <!-- Menu 1st hierarchy starts here-->

            <mat-list-option
              *ngIf="menu.name == 'CDP'
                  ? checkCdpPer()
                  : menu.dspType == 'nonDSP'
                  ? !getSavedAgencyAdvertiser() && isClientWithPerm(menu)
                  : isClientWithPerm(menu)
              "
              [ngClass]="{
                selected_submenu_item: menu.entityGroup
                  ? selectedEntityGroup == menu.entityGroup
                  : selectedOptionsGroup == menu.group,
                expandable_options: true
              }"
              (click)="
                selectCategoryOptions(
                  null,
                  getMenuNavLink(menu),
                  menu.entityGroup ? getPlatFormType() : menu.dspType,
                  menu.entityGroup
                    ? this.selectedEntityGroup != menu.entityGroup
                    : selectedPlatformType != menu.dspType,
                  getAdspRegion(),
                  menu.entityGroup,
                  false,
                  menu.name == 'CDP'
                )
              "
              [selected]="
                menu.entityGroup
                  ? selectedEntityGroup == menu.entityGroup
                  : selectedOptionsGroup == menu.group
              "
            >
              <div class="expand_options">
                <span
                  [matTooltip]="menu.toolTip ? menu.toolTip : ''"
                  [ngClass]="{
                    expand_options_title: true,
                    selected_submenu_title: menu.entityGroup
                      ? selectedEntityGroup == menu.entityGroup
                      : selectedOptionsGroup == menu.group,
                    'active-sub-option': menu.entityGroup
                      ? selectedEntityGroup == menu.entityGroup
                      : selectedOptionsGroup == menu.group
                  }"
                >
                  <ng-container *ngIf="menu.faIconClass; else matIcon">
                    <i [className]="menu.faIconClass"></i>
                  </ng-container>

                  <ng-template #matIcon>
                    <ng-container *ngIf="menu.matIconClass; else textIcon">
                      <mat-icon class="me-3">{{ menu.matIconClass }}</mat-icon>
                    </ng-container>
                  </ng-template>

                  <ng-template #textIcon>
                    <span class="me-3 text-icon">{{ menu.textIcon }}</span>
                  </ng-template>

                  {{ menu.name }}
                </span>

                <ng-container *ngIf="menu.children && menu.children.length > 0">
                  <mat-icon
                    *ngIf="selectedEntityGroup == menu.entityGroup"
                    class="expand_options_icon material-icons-outlined"
                  >
                    expand_less
                  </mat-icon>
                  <mat-icon
                    class="expand_options_icon material-icons-outlined"
                    *ngIf="selectedEntityGroup != menu.entityGroup"
                  >
                    expand_more
                  </mat-icon>
                </ng-container>
              </div>
            </mat-list-option>

            <!-- Menu 1st hierarchy ends here-->

            <div *ngIf="selectedEntityGroup == menu.entityGroup" class="ms-3">
              <ng-container *ngFor="let subMenu of menu.children">
                <!-- Menu 2nd hierarchy starts here-->

                <mat-list-option
                  *ngIf="
                    subMenu.dspType == 'tdsp_hyperlocal' ? isHyperlocalMenuAllowed(subMenu) && dspTypes[subMenu.dspType] :
                    subMenu.dspType == 'nonDSP'
                      ? !getSavedAgencyAdvertiser() && isClientWithPerm(subMenu)
                      :  subMenu.dspType == 'vdsp'? dspTypes[subMenu.dspType] && platformRole : dspTypes[subMenu.dspType] 
                  "
                  [ngClass]="{
                    selected_submenu_item:
                      subMenu.dspType == 'nonDSP'
                        ? selectedOptionsGroup == subMenu.group
                        : selectedPlatformType == subMenu.dspType,
                    expandable_options: true
                  }"
                  (click)="
                    selectCategoryOptions(
                      getGroup(subMenu, 'advertiser'),
                      getSubMenuNavLink(subMenu, 'advertiser'),
                      subMenu.dspType,
                      !subMenu.children
                        ? true
                        : selectedPlatformType != subMenu.dspType,
                      subMenu.adspRegion,
                      menu.entityGroup
                    )
                  "
                  [selected]="selectedPlatformType == subMenu.dspType"
                >
                  <div class="expand_options">
                    <span
                      [matTooltip]="subMenu.toolTip ? subMenu.toolTip : ''"
                      [ngClass]="{
                        expand_options_title: true,
                        selected_submenu_title:
                          subMenu.dspType == 'nonDSP'
                            ? selectedOptionsGroup == subMenu.group
                            : selectedPlatformType == subMenu.dspType,
                        'active-sub-option':
                          subMenu.dspType == 'nonDSP'
                            ? selectedOptionsGroup == subMenu.group
                            : selectedPlatformType == subMenu.dspType
                      }"
                    >
                      <ng-container *ngIf="subMenu.faIconClass; else matIcon">
                        <i [className]="subMenu.faIconClass"></i>
                      </ng-container>

                      <ng-template #matIcon>
                        <ng-container
                          *ngIf="subMenu.matIconClass; else textIcon"
                        >
                          <mat-icon class="me-3">{{
                            subMenu.matIconClass
                          }}</mat-icon>
                        </ng-container>
                      </ng-template>

                      <ng-template #textIcon>
                        <span class="me-3 text-icon">{{
                          subMenu.textIcon
                        }}</span>
                      </ng-template>

                      {{ subMenu.name }}
                    </span>

                    <ng-container
                      *ngIf="subMenu.children && subMenu.children.length > 0"
                    >
                      <mat-icon
                        *ngIf="selectedPlatformType == subMenu.dspType"
                        class="expand_options_icon material-icons-outlined"
                      >
                        expand_less
                      </mat-icon>
                      <mat-icon
                        class="expand_options_icon material-icons-outlined"
                        *ngIf="selectedPlatformType !== subMenu.dspType"
                      >
                        expand_more
                      </mat-icon>
                    </ng-container>
                  </div>
                </mat-list-option>

                <!-- Menu 2nd hierarchy ends here-->

                <div
                  *ngIf="selectedPlatformType == subMenu.dspType"
                  class="ms-3"
                >
                  <ng-container *ngFor="let subMenuChild of subMenu.children">
                    <!-- Menu 3rd hierarchy starts here-->
                    <div
                      *ngIf="getAdvertiserGroupListPermission(subMenuChild)"
                      [matTooltip]="
                        isDashboardComingSoon(subMenu, subMenuChild)
                          ? 'Coming Soon'
                          : ''
                      "
                      [style.cursor]="
                        isDashboardComingSoon(subMenu, subMenuChild)
                          ? 'not-allowed'
                          : 'pointer'
                      "
                    >
                      <mat-list-option
          
                        [ngClass]="{
                          selected_submenu_item:
                            !isDashboardComingSoon(subMenu, subMenuChild) &&
                            selectedOptionsGroup == subMenuChild.group,
                          report_background: subMenuChild.listPer == 'report',
                          coming_soon_section: isDashboardComingSoon(
                            subMenu,
                            subMenuChild
                          )
                        }"
                        class="expandable_options"
                        (click)="
                          isDashboardComingSoon(subMenu, subMenuChild)
                            ? $event.stopPropagation()
                            : selectCategoryOptions(
                                subMenuChild.group,
                                getNavLink(subMenuChild, subMenuChild.entity),
                                subMenu.dspType,
                                !subMenuChild.subMenuOptions
                                  ? true
                                  : selectedOptionsGroup != subMenuChild.group,
                                subMenu.adspRegion,
                                menu.entityGroup,
                                true
                              )
                        "
                      >
                        <div class="expand_options">
                          <span
                            [ngClass]="{
                              'nav-link': true,
                              expand_options_title: true,
                              selected_submenu_title:
                                selectedOptionsGroup == subMenuChild.group,
                              'active-sub-option':
                                selectedOptionsGroup == subMenuChild.group
                            }"
                          >
                            <ng-container *ngIf="subMenuChild.faIconClass; else matIcon">
                              <i [className]="subMenuChild.faIconClass"></i>
                            </ng-container>

                            <ng-template #matIcon>
                              <ng-container *ngIf="subMenuChild.matIconClass; else textIcon">
                                <mat-icon class="me-3">{{ subMenuChild.matIconClass }}</mat-icon>
                              </ng-container>
                            </ng-template>

                            <ng-template #textIcon>
                              <span class="me-3 text-icon">{{ subMenuChild.textIcon }}</span>
                            </ng-template>

                            <span class="label-text">
                              {{
                                !campaignMenus.has(subMenuChild.name) &&
                                getSavedAgencyAdvertiser()
                                  ? "Advertiser"
                                  : ""
                              }}
                              {{ subMenuChild.name }}<sup *ngIf="subMenuChild.badge" class="nav-badge">{{ subMenuChild.badge }}</sup>
                            </span>
                          </span>

                          <ng-container *ngIf="subMenuChild.children?.length > 0">
                            <mat-icon
                              *ngIf="selectedOptionsGroup == subMenuChild.group"
                              class="expand_options_icon material-icons-outlined"
                            >
                              expand_less
                            </mat-icon>
                            <mat-icon
                              class="expand_options_icon material-icons-outlined"
                              *ngIf="selectedOptionsGroup !== subMenuChild.group"
                            >
                              expand_more
                            </mat-icon>
                          </ng-container>
                        </div>
                      </mat-list-option>
                    </div>

                    <!-- Menu 3rd hierarchy ends here-->

                    <ng-container *ngIf="subMenuChild.children?.length > 0">
                      <div
                        *ngIf="
                          selectedOptionsGroup == subMenuChild.group &&
                          getAdvertiserGroupListPermission(subMenuChild)
                        "
                        class="ms-3"
                      >
                        <mat-nav-list role="list">
                          <!-- Menu 4th hierarchy starts here-->

                          <ng-container
                            *ngFor="
                              let childOption of subMenuChild.children;
                              let lastsubMenu = last
                            "
                          >
                            <mat-list-item
                              [ngClass]="{
                                'border-bottom':
                                  lastsubMenu ||
                                  getVDSPLibraryLastMenu(subMenu, childOption),
                                'nav-menu-list-item': true
                              }"
                              *ngIf="getAdvertiserListPermission(childOption)"
                              (click)="
                                childOption.navLink
                                  ? routeURL(
                                      { routes: childOption.navLink },
                                      subMenu.adspRegion
                                    )
                                  : routeToViewReport(subMenu.dspType);
                                childOption.navLink
                                  ? (suboptionSelected = childOption.group)
                                  : ''
                              "
                            >
                              <ng-container
                                *ngIf="childOption.faIconClass; else matIcon"
                              >
                                <i
                                  class="{{ childOption.faIconClass }}"
                                  [ngClass]="{
                                    'active-sub-option':
                                      suboptionSelected == childOption.group
                                  }"
                                >
                                </i>
                              </ng-container>
                              <ng-template #matIcon>
                                <mat-icon
                                  [ngClass]="{
                                    'active-sub-option':
                                      suboptionSelected == childOption.group
                                  }"
                                >
                                  {{ childOption.matIconClass }}
                                </mat-icon>
                              </ng-template>
                              <a
                                [ngClass]="{
                                  'nav-link': true,
                                  'active-sub-option bold':
                                    suboptionSelected == childOption.group
                                }"
                                routerLinkActive="active-list-item"
                              >
                                <ng-container
                                  *ngIf="!childOption.navLink; else displayName"
                                >
                                  <span
                                    [ngClass]="{
                                      disable: accessViewReport(subMenu.dspType)
                                        ? currentUrl.includes('view-forecast')
                                          ? false
                                          : true
                                        : false
                                    }"
                                  >
                                    {{
                                      !campaignMenus.has(
                                        childOption.name
                                      ) && getSavedAgencyAdvertiser()
                                        ? "Advertiser"
                                        : ""
                                    }}
                                    {{ childOption.name }}
                                  </span>
                                </ng-container>
                                <ng-template #displayName>
                                  {{
                                    !campaignMenus.has(childOption.name) &&
                                    getSavedAgencyAdvertiser()
                                      ? "Advertiser"
                                      : ""
                                  }}
                                  {{ childOption.name }}
                                </ng-template>
                              </a>
                            </mat-list-item>
                          </ng-container>
                        </mat-nav-list>
                        <!-- Menu 4th hierarchy starts here-->
                      </div>
                    </ng-container>
                  </ng-container>
                </div>
              </ng-container>
            </div>
          </ng-container>
        </mat-selection-list>
      </div>
    </div>
    <!-- Advertiser Menu ends Here -->

    <!-- Create/Edit/View step Menu starts Here -->
    <div *ngIf="sideMenu == 'option_menu'" class="secondary_sub_menu">
      <div class="landing_page_link" style="margin-bottom: 14px">
        <span class="landing_page_link_icon">
          <i class="fas fa-caret-left"></i>
        </span>
        <span class="landing_page_link_title">
          <a
            style="color: black"
            [queryParams]="{
              advertiser_id: getSavedAdvertiser(),
              agency_advertiser_id: getSavedAgencyAdvertiser(),
              duplicate: null,
              segment_type: null
            }"
            [routerLink]="getBackLink(componentId)"
            queryParamsHandling="merge"
            >Back to
            {{
              defaultSideBar.insertion_order.view == false &&
              componentName == "Line Items"
                ? "Campaigns"
                : componentName
            }}
            <!-- isClientPolitical() && componentName == 'Inventory Lists' ? 'Domain App Lists' : isClientPolitical() &&
                 componentName == 'Segment Pixel' ? 'Audience': -->
          </a>
        </span>
      </div>
      <mat-selection-list
        class="secondary_sub_menu_options"
        [multiple]="false"
        *ngIf="
          role != 'agency_reporting_user' && role != 'advertiser_reporting_user'
        "
      >
        <mat-list-option
          [ngClass]="{
            selected_submenu_item: selectedTab === item.id,
            non_selected_option: selectedTab != item.id
          }"
          *ngFor="let item of subMenuOptions"
          (click)="item.active ? selectedTabFromSubMenu(item) : ''"
        >
          <div
            [ngClass]="{
              selected_submenu_title: selectedTab === item.id,
              inactive_menu_option: !item.active
            }"
            class="secondary_sub_menu_item"
          >
            <span
              [ngClass]="{ 'active-sub-option bold': selectedTab === item.id }"
            >
              {{ item.name }}
            </span>
            <span><i class="fas fa-caret-right"></i></span>
          </div>
        </mat-list-option>
      </mat-selection-list>
    </div>
    <!-- Create/Edit/View step Menu ends Here -->
  </div>
</div>
